var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 7.70204C3.33301 6.26371 3.33301 5.54454 3.68573 5.03227C3.82404 4.83141 3.99791 4.65753 4.19877 4.51923C4.71104 4.1665 5.43021 4.1665 6.86854 4.1665V4.1665C7.4951 4.1665 7.80839 4.1665 8.09849 4.25672C8.21468 4.29285 8.32733 4.33952 8.43504 4.39613C8.70397 4.53747 8.92549 4.75899 9.36854 5.20204L9.66144 5.49493C10.2395 6.07299 10.5285 6.36202 10.8961 6.51426C11.2636 6.6665 11.6724 6.6665 12.4899 6.6665H12.6663C14.552 6.6665 15.4948 6.6665 16.0806 7.25229C16.6663 7.83808 16.6663 8.78089 16.6663 10.6665V11.8332C16.6663 13.7188 16.6663 14.6616 16.0806 15.2474C15.4948 15.8332 14.552 15.8332 12.6663 15.8332H7.333C5.44739 15.8332 4.50458 15.8332 3.91879 15.2474C3.33301 14.6616 3.33301 13.7188 3.33301 11.8332V7.70204Z",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.140b996bfd6e193456ed2bd6d8df4896.svg";
export { ForwardRef as ReactComponent };